import React from "react";
import PropTypes from "prop-types";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import { StyledButton, StyledCircularProgress } from "./style";

interface StandardButtonProps {
  children: React.ReactNode;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hidden?: boolean;
  disabled?: boolean;
  variant?: MuiButtonProps["variant"];
  classes?: object | string; // For MuiButton classes override
  type?: "button" | "submit" | "reset";
  customColor?: "danger" | "neutralPrimary" | "neutralSecondary";
  loading?: boolean;
  dense?: boolean;
}

const StandardButton: React.FC<StandardButtonProps> = ({
  children,
  endIcon,
  startIcon,
  onClick,
  hidden,
  disabled = false,
  variant = "outlined",
  classes: customClasses,
  type = "button",
  customColor,
  loading,
  dense = false,
}) => {
  return (
    <StyledButton
      variant={variant}
      endIcon={endIcon}
      startIcon={startIcon}
      disabled={disabled || loading}
      type={type}
      customColor={customColor}
      dense={dense}
      hidden={hidden}
      onClick={onClick}
      className={typeof customClasses === "string" ? customClasses : undefined}
      sx={typeof customClasses === "object" ? customClasses : undefined}
    >
      {loading && <StyledCircularProgress size={14} />}
      {children}
    </StyledButton>
  );
};

StandardButton.propTypes = {
  children: PropTypes.any.isRequired,
  endIcon: PropTypes.element,
  startIcon: PropTypes.element,
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  classes: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  customColor: PropTypes.oneOf([
    "danger",
    "neutralPrimary",
    "neutralSecondary",
  ]),
  loading: PropTypes.bool,
  dense: PropTypes.bool,
};

export default StandardButton;
